import "../styles/Home.scss";

export const Disclaimer = () => {
    return <p id="disclaimer">This Website is being rebuilt</p>
}